import type { ReactNode } from 'react';

import { Dialog, type DialogSize } from './Dialog';

function EntityDialog({
  children,
  onClose,
  open,
  size,
  title,
}: {
  children: ReactNode;
  onClose: () => void;
  open: boolean;
  size?: DialogSize;
  title: ReactNode;
}) {
  return (
    <Dialog onClose={onClose} open={open} size={size} title={title}>
      {children}
    </Dialog>
  );
}

export function EntityCreateDialog(props: {
  children: ReactNode;
  onClose: () => void;
  open: boolean;
  size?: DialogSize;
  title: ReactNode;
}) {
  return <EntityDialog {...props} />;
}

export function EntityEditDialog(props: {
  children: ReactNode;
  onClose: () => void;
  open: boolean;
  size?: DialogSize;
  title: ReactNode;
}) {
  return <EntityDialog {...props} />;
}

export function EntityManageDialog(props: {
  children: ReactNode;
  onClose: () => void;
  open: boolean;
  size?: DialogSize;
  title: ReactNode;
}) {
  return <EntityDialog {...props} />;
}

export function EntityViewDialog(props: {
  children: ReactNode;
  onClose: () => void;
  open: boolean;
  size?: DialogSize;
  title: ReactNode;
}) {
  return <EntityDialog {...props} />;
}
